import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import RootTemplate from '../RootTemplate';
import MainPage from '../pages/MainPage';

// Ліниве завантаження сторінок
const SdufDetailsPage = lazy(() => import('../pages/SdufDetailsPage'));
const KalipsoDetailsPage = lazy(() => import('../pages/KalipsoDetailsPage'));
const CommunaDetailsPage = lazy(() => import('../pages/CommunaDetailsPage'));
const FahrschuleDetailsPage = lazy(() => import('../pages/FahrschuleDetailsPage'));
const RiaPlatformsDetailsPage = lazy(() => import('../pages/RiaPlatformsDetailsPage'));
// Компонент для відображення під час завантаження лінивих компонентів
const Loading = () => <div>Loading...</div>;

const router = createBrowserRouter([
    {
        path: "/",
        element: <RootTemplate />,
        children: [
            {
                path: "/",
                element: (<MainPage />),
            },
            {
                path: "/sduf",
                element: (
                    <Suspense fallback={<Loading />}>
                        <SdufDetailsPage />
                    </Suspense>
                ),
            },
            {
                path: "/kalipso",
                element: (
                    <Suspense fallback={<Loading />}>
                        <KalipsoDetailsPage />
                    </Suspense>
                ),
            },
            {
                path: "/communa",
                element: (
                    <Suspense fallback={<Loading />}>
                        <CommunaDetailsPage />
                    </Suspense>
                ),
            },
            {
                path: "/123fahrschule",
                element: (
                    <Suspense fallback={<Loading />}>
                        <FahrschuleDetailsPage />
                    </Suspense>
                ),
            },
            {
                path: "/ria-platforms",
                element: (
                    <Suspense fallback={<Loading />}>
                        <RiaPlatformsDetailsPage />
                    </Suspense>
                ),
            }
        ]
    },
]);

export { router };